import { render, staticRenderFns } from "./DataFieldV2.vue?vue&type=template&id=748a8c9a&scoped=true"
import script from "./DataFieldV2.vue?vue&type=script&lang=js"
export * from "./DataFieldV2.vue?vue&type=script&lang=js"
import style0 from "./DataFieldV2.vue?vue&type=style&index=0&id=748a8c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748a8c9a",
  null
  
)

export default component.exports